class AplicacaoController extends AbstractController
  @$inject = ['$injector', '$scope', 'pathService', 'aplicacaoService']

  constructor: ($injector, @scope, pathService, @aplicacaoService) ->
    super($injector)

    @loadingTracker = @promiseTracker()
    url = "#{pathService.getViewUrl()}eficiencia-fiscal/view/configuracao/icms/aplicacao/"
    @modalAplicacao = @openPopup(url + "modal.html", 'aplicacaoModalController as ctrl')

    @loadData()

  loadData: ->
    @loadingTracker.addPromise @aplicacaoService.getList((data) =>
      @listOfAplicacao = data
    )

  adicionar: ->
    @modalAplicacao({aplicacao: -> {}}, (result) =>
      if result.ok
        @listOfAplicacao.push(result.data)
    )

  editar: (aplicacao) ->
    @modalAplicacao({aplicacao: -> aplicacao}, (result) =>
      if result.ok
        aplicacao = result.data

        index = @listOfAplicacao.getIndex(aplicacao.id, 'id')
        @listOfAplicacao[index] = aplicacao
    )

  remover: (aplicacao) ->
    Confirm.warning("Atenção", "Deseja realmente remover a aplicação <strong>#{aplicacao.nome}</strong>? Esta ação <strong>não poderá</strong> ser desfeita.",
      {
        "Não": null
        "Sim": =>
          @aplicacaoService.delete(aplicacao.id, (data) =>
            Alert.success("Aplicação <strong>#{aplicacao.nome}</strong> removida com sucesso.", 'Sucesso!')
            @listOfAplicacao.remove(@listOfAplicacao.getIndex(aplicacao.id, 'id'))
          )
      })

class AplicacaoModalController extends AbstractController
  @$inject = ['$injector', 'aplicacaoService', '$uibModalInstance', 'aplicacao']

  constructor: ($injector, @aplicacaoService, @modalInstance, aplicacao) ->
    super($injector)

    @submitTracker = @promiseTracker()

    @aplicacao = angular.copy aplicacao

  salvar: (form) ->
    if form.$valid
      @submitTracker.addPromise @aplicacaoService.save(@aplicacao, (data) =>
        Alert.success("Aplicação  <strong>#{@aplicacao.nome}</strong> #{if @aplicacao.id then 'atualizada' else 'criada'} com sucesso.", 'Sucesso!')
        @modalInstance.close(new Retorno(true, null, data))
      )

angular.module('eficienciaFiscalModule').controller('aplicacaoController', AplicacaoController)
angular.module('eficienciaFiscalModule').controller('aplicacaoModalController', AplicacaoModalController)